//-- Copyright (c) 2021 TMT Insights Group, LLC
import { DateTimeDisplay, PolarisIcon } from '@/exports/columnCommonComponents';
import React from 'react';
import AvailTerritory from './AvailTerritory';
import { ColumnConfig } from '@/__configs/config_types';

type NBCAvail = {
  hierarchy: string;
  download: 'Yes' | 'No';
  start: string;
  end: string;
  status: string;
  territory: string;
  title_entity_id: number;
  created_at: string;
};

export default {
  hierarchy: {
    label: 'BU'
  },
  mvpd_name: {
    label: 'Partner',
    sortField: 'customer__name'
  },
  territory: {
    label: 'Territory',
    render: (cell: NBCAvail['territory']) => <AvailTerritory territory={cell} />
  },
  start: {
    label: 'Start Date',
    render: (cell: NBCAvail['start']) => <DateTimeDisplay showTZ>{cell}</DateTimeDisplay>
  },
  end: {
    label: 'End Date',
    render: (cell: NBCAvail['end']) => <DateTimeDisplay showTZ>{cell}</DateTimeDisplay>
  },
  status: {
    label: 'Status'
  },
  source: {
    label: 'Source'
  },
  download: {
    label: 'Downloadable',
    disableSort: true,
    render: (cell: NBCAvail['download']) => <PolarisIcon icon={cell === 'Yes' ? 'checkbox_checked' : 'checkbox_unchecked'} />
  }
} as Record<string, ColumnConfig<NBCAvail, any>>;
